import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { StateService } from '../../shared/state/state.service';
import { BaseComponent } from '../general/base/base.component';
import { AuthService } from '../../auth/auth.service';
import { OverlayPanelComponent } from '../overlay-panel/overlay-panel.component';
import { TranslateService } from '@ngx-translate/core';
import { UserSettingState } from '../../shared/state/user-setting.state';
import { version } from '../../../environments/version';
import { Router } from '@angular/router';

@Component({
  selector: 'qm-user-settings',
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.scss']
})
export class UserSettingsComponent extends BaseComponent implements OnInit {

  @ViewChild('overlay', { static: true })
  public overlay: OverlayPanelComponent;

  @ViewChild('template')
  public template: TemplateRef<any>;
  public settings: UserSettingState;
  public version: string = version;

  constructor(private stateService: StateService,
              private translate: TranslateService,
              private auth: AuthService,
              private router: Router) {
    super();
    this.name = 'UserSettingsComponent';
  }
  ngOnInit() {
    this.settings = this.stateService.getPartOfState('settingsState');
  }

  /**
   * Changelanguage or the page
   */
  public changeLanguage() {
    switch (this.settings.language) {
      case 'fi':
        this.translate.use('en');
        this.settings.language = 'en';
        this.stateService.updateState('settingsState', this.settings);
        break;
      case 'en':
        this.translate.use('fi');
        this.settings.language = 'fi';
        this.stateService.updateState('settingsState', this.settings);
        break;
    }
    this.refreshAfterLanguageChange();
  }

  public refreshAfterLanguageChange() {
    location.reload();
  }

  public navigateToSuperuser() {
    this.router.navigateByUrl('/superuser', {
      state: {
        originRoute: this.router.url
      }
    });
  }

  /**
   * Resets state and reloads page
   */
  public resetState() {
    this.stateService.resetState();
  }

  /**
   * Logout function, send logout command to Auth0
   */
  public logOutUser() {
    this.auth.logout();
  }
}
